import { Container, Store, wrap } from 'AppReact';
import { GrayFooterWrapper, Mr2, Mt2 } from 'wrappers';
import { Icon, SecondaryTextSm } from 'atoms';
import { DarkLogoTextSvg } from 'components/icons';

export const definition = {
  name: "Header",
  props: { property: Store },
  elements: [
    {
      component: wrap(wrap(SecondaryTextSm, Mr2), Mt2),
      name: 'Powered',
      displayValue: ({ }) => 'Powered by'
    },
    {
      component: Icon,
      name: 'Icon',
      displayValue: () => DarkLogoTextSvg({ width: 90, height: 38 }),
    }
  ]
};

export default wrap(Container(definition), GrayFooterWrapper);
